import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconClip = props => (
  <SvgIcon {...props} viewBox="0 0 9 18">
    <path d="m7.7727 4.0909v9.4091c0 1.8082-1.4646 3.2727-3.2727 3.2727-1.8082 0-3.2727-1.4645-3.2727-3.2727v-10.227c0-1.1291 0.91637-2.0455 2.0455-2.0455s2.0454 0.91637 2.0454 2.0455v8.5909c0 0.45-0.36818 0.8182-0.81818 0.8182s-0.81818-0.3682-0.81818-0.8182v-7.7727h-1.2273v7.7727c0 1.1291 0.91636 2.0455 2.0454 2.0455 1.1291 0 2.0454-0.9164 2.0454-2.0455v-8.5909c0.0001-1.8085-1.4644-3.2731-3.2726-3.2731-1.8081 0-3.2727 1.4646-3.2727 3.2727v10.227c0 2.487 2.0127 4.5 4.5 4.5s4.5-2.013 4.5-4.5v-9.4091h-1.2273z" />
  </SvgIcon>
);

export default IconClip;



// WEBPACK FOOTER //
// ./src/components/icons/IconClip.js